import { Album, UrlItem } from '../types';

export function migrateAlbums(oldAlbums: any[], deviceId: string): Album[] {
  return oldAlbums.map(album => {
    // If already migrated, just return
    if (album.urls && album.urls.length > 0 && typeof album.urls[0] === 'object') {
      return album as Album;
    }

    const now = Date.now();
    const migratedUrls: UrlItem[] = (album.urls || []).map((url: string) => ({
      id: crypto.randomUUID(),
      url,
      createdAt: album.createdAt || now,
      updatedAt: album.createdAt || now,
      deletedAt: null
    }));

    return {
      id: album.id,
      name: album.name,
      urls: migratedUrls,
      createdAt: album.createdAt || now,
      updatedAt: now,
      deletedAt: null,
      deviceId: album.deviceId || deviceId,
      syncVersion: album.syncVersion || 0
    };
  });
}